const incidentRelatedUrls = [
  //Incident Main
  '/incidents/add',
  '/incidents/edit/:incId',
  //Address
  '/incidents/add/addresses',
  '/incidents/edit/:incId/addresses/:addressId',
  //Parties
  '/incidents/add/parties',
  '/incidents/edit/:incId/parties/:incPersonId',
  //Missing person
  '/incidents/add/missing-person',
  '/incidents/edit/missing-person/:ptsIncPersonId',
  //Suspects
  '/incidents/add/suspects',
  '/incidents/edit/:incId/suspects/:incPersonId',
  //Offense
  '/incidents/add/offenses',
  '/incidents/edit/:incId/offenses/:offenseId',
  //Domestic Violence
  '/incidents/add/domestic-violence',
  //IBRS error
  '/incidents/ibrs',
  //Properties
  '/incidents/add/item',
  '/incidents/edit/:incId/item/:propId',
  '/incidents/add/firearm',
  '/incidents/edit/:incId/firearm/:propId',
  '/incidents/add/jewelry',
  '/incidents/edit/:incId/jewelry/:propId',
  '/incidents/add/vehicle',
  '/incidents/edit/:incId/vehicle/:propId',
  '/incidents/add/structure',
  '/incidents/edit/:incId/structure/:propId',
  '/incidents/add/substance',
  '/incidents/edit/:incId/substance/:propId',
  //Evidence
  '/incidents/add/evidence',
  '/incidents/:incId/evidence/:evidenceId/add/parties',
  '/incidents/:incId/evidence/:evidenceId/edit/parties/:incPersonId',
  '/incidents/edit/:incId/evidence/:evidenceId',
  //Narrative
  '/incidents/add/narratives',
  '/incidents/edit/:incId/narratives/:narrativeId',
  //After action report
  '/incidents/add/actionReport',
  '/incidents/edit/:incId/actionReport/:actionReportId',
  '/incidents/:incId/actionReport/:actionReportId/add/parties',
  '/incidents/edit/:incId/actionReport/:actionReportId/parties/:incPersonId',
  //notification - not available yet
  '/incidents/add/notifications',
  '/incidents/edit/:incId/notifications/:propId',
  //alerts - not available yet
  '/incidents/add/alerts',
  '/incidents/edit/:incId/alerts/:propId',
  //sop - not available yet
  '/incidents/add/sop',
  '/incidents/edit/:incId/sop/:propId',
  //dialogs not a page
  '/incidents/add/zones',
  '/incidents/edit/:incId/zones/:propId',
  '/incidents/add/dispositions',
  '/incidents/edit/:incId/dispositions/:propId',
  '/incidents/add/tags',
  '/incidents/edit/:incId/tags/:propId',
];

const incidentAddressUrls = [
  '/incidents/add/addresses',
  '/incidents/edit/:incId/addresses/:addressId',
];

const incidentPartiesRelatedUrls = [
  '/incidents/add/parties',
  '/incidents/edit/:incId/parties/:incPersonId',
];

const incidentOffenseRelatedUrls = [
  '/incidents/add/offenses',
  '/incidents/edit/:incId/offenses/:offenseId',
];

const incidentPropertyRelatedUrls = [
  '/incidents/add/item',
  '/incidents/edit/:incId/item/:propId',
  '/incidents/add/firearm',
  '/incidents/edit/:incId/firearm/:propId',
  '/incidents/add/jewelry',
  '/incidents/edit/:incId/jewelry/:propId',
  '/incidents/add/vehicle',
  '/incidents/edit/:incId/vehicle/:propId',
  '/incidents/add/structure',
  '/incidents/edit/:incId/structure/:propId',
  '/incidents/add/substance',
  '/incidents/edit/:incId/substance/:propId',
];

const incidentEvidenceRelatedUrls = [
  '/incidents/add/evidence',
  '/incidents/edit/:incId/evidence/:evidenceId',
  '/incidents/:incId/evidence/:evidenceId/add/parties',
  '/incidents/:incId/evidence/:evidenceId/edit/parties/:incPersonId',
];

const incidentNarrativeRelatedUrls = [
  '/incidents/add/narratives',
  '/incidents/edit/:incId/narratives/:narrativeId',
];

const incidentActionReportUrls = [
  '/incidents/add/actionReport',
  '/incidents/edit/:incId/actionReport/:actionReportId',
];

const incidentActionReportPartyUrls = [
  '/incidents/:incId/actionReport/:actionReportId/add/parties',
  '/incidents/edit/:incId/actionReport/:actionReportId/parties/:incPersonId',
];

const citationRelatedUrls = ['/citations/add', '/citations/edit/:id'];

const propertiesRelatedsUrls = [
  '/records/:type',
  '/records/add/item',
  '/records/edit/item',
  '/records/edit/firearm',
  '/records/add/firearm',
  '/records/add/jewelry',
  '/records/edit/jewelry',
  '/records/edit/vehicle/:vehicleId',
  '/records/add/vehicle',
  '/records/add/substance',
  '/records/edit/substance',
  '/records/edit/structure',
  '/records/add/structure',
  '/search/vehicle-towings',
];

const personRelatedUrls = [
  '/search/images',
  '/search/credentials',
  '/search/phone-numbers',
  '/names',
];
const formatUrls = (list = [], parent) => {
  const obj = {};
  list.forEach((item) => {
    obj[item] = { parent };
  });
  return obj;
};
const routePermissionDefination = {
  '/incidents': { name: 'Incidents', type: 'rms', agency: 'specific' },
  '/citations': { name: 'Citations', type: 'globals', agency: 'any' },
  '/evidence': { name: 'Evidence', type: 'rms', agency: 'specific' },
  '/warrants': { name: 'Warrants', type: 'globals', agency: 'any' },
  '/properties': { name: 'Property', type: 'rms', agency: 'specific' },
  '/persons': { name: 'People', type: 'globals', agency: 'any' },
  '/addresses': { name: 'Addresses', type: 'globals', agency: 'any' },
  '/places': { name: 'Places', type: 'globals', agency: 'any' },
  '/search/bulletin': { name: 'Alerts', type: 'cad', agency: 'any' },
  '/search/agencies': { name: 'Agencies', type: 'globals', agency: 'any' },
  '/search/employees': { name: 'Employees', type: 'globals', agency: 'any' },
  '/search/zones': { name: 'Zones', type: 'globals', agency: 'any' },
  '/incidents/address': { name: 'Address', type: 'rms', agency: 'specific', parent: '/incidents' },
  '/incidents/parties': { name: 'Party', type: 'rms', agency: 'specific', parent: '/incidents' },
  '/incidents/offenses': { name: 'Offense', type: 'rms', agency: 'specific', parent: '/incidents' },
  '/incidents/property': {
    name: 'Property',
    type: 'rms',
    agency: 'specific',
    parent: '/incidents',
  },
  '/incidents/evidence': {
    name: 'Evidence',
    type: 'rms',
    agency: 'specific',
    parent: '/incidents',
  },
  '/incidents/narratives': {
    name: 'Narrative',
    type: 'rms',
    agency: 'specific',
    parent: '/incidents',
  },
  '/incidents/actionReport': {
    name: 'Action Report',
    type: 'rms',
    agency: 'specific',
    parent: '/incidents',
  },
  '/incidents/action-report-party': {
    name: 'Action Party',
    type: 'rms',
    agency: 'specific',
    parent: '/incidents',
  },

  '/records/add/evidence': { name: 'Evidence Record', type: 'evidence', agency: 'specific' },
  '/records/edit/evidence/:evidenceId': {
    name: 'Evidence Record',
    type: 'evidence',
    agency: 'specific',
    parent: '/evidence',
  },
  '/records/evidence/:evidenceId/add/parties': {
    name: 'Evidence Parties',
    type: 'evidence',
    agency: 'specific',
    parent: '/evidence',
  },
  '/records/evidence/:evidenceId/edit/parties/:incPersonId': {
    name: 'Evidence Parties',
    type: 'evidence',
    agency: 'specific',
    parent: '/evidence',
  },

  ...formatUrls(incidentRelatedUrls, '/incidents'),
  ...formatUrls(incidentAddressUrls, '/incidents/address'),
  ...formatUrls(incidentPartiesRelatedUrls, '/incidents/parties'),
  ...formatUrls(incidentOffenseRelatedUrls, '/incidents/offenses'),
  ...formatUrls(incidentPropertyRelatedUrls, '/incidents/property'),
  ...formatUrls(incidentEvidenceRelatedUrls, '/incidents/evidence'),
  ...formatUrls(incidentNarrativeRelatedUrls, '/incidents/narratives'),
  ...formatUrls(incidentActionReportUrls, '/incidents/actionReport'),
  ...formatUrls(incidentActionReportPartyUrls, '/incidents/action-report-party'),
  ...formatUrls(citationRelatedUrls, '/citations'),
  ...formatUrls(personRelatedUrls, '/persons'),
  ...formatUrls(propertiesRelatedsUrls, '/properties'),
};
export default routePermissionDefination;
